import React, { useState, useEffect } from "react";
import { MdUpload } from "react-icons/md";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { EditCeoMessageApi } from "Services/allApi";
import { CeoMessageApi } from "Services/allApi";

const CeoMessage = () => {
    const [formData, setFormData] = useState({
        image: "",
        heading: "",
        description: "",
        point1: "",
        point2: "",
        point3: "",
        description_second: "",
        description_third: "",
        name: "",
        role: "",
        company: "",
        linkdin: "",
        instagram: "",
        
      });
      const [currentImages, setCurrentImages] = useState({
        image: ""
      });
    
      const [id, setId] = useState(null);
    
    
      useEffect(() => {
        
        fetchData();
      }, []);
    
      const fetchData = async () => {
        try {
          const response = await CeoMessageApi(); // Replace with actual API call
          if (response && !response.error) {
            const data = response.data; // Assuming response is a single object
            setId(data.id);
            setFormData({
              image: "",
              description: data.description || "",
              point1: data.point1 || "",
              point2: data.point2 || "",
              point3: data.point3 || "",
              description_second: data.description_second || "",
              description_third: data.description_third || "",
              name: data.name || "",
              role: data.role || "",
              company: data.company || "",
              linkdin: data.linkdin || "",
              instagram: data.instagram || ""
            });
            setCurrentImages({
              image: data.image || "",

            });
          } else {
            toast.error("Error fetching about content data.");
          }
        } catch (error) {
          console.error("Error fetching about content:", error);
          toast.error("Failed to fetch about content!");
        }
      };
    
      const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
          // Validate file type (check if it's an image)
          if (!file.type.startsWith("image/")) {
            alert("Please upload a valid image file.");
            return;
          }
    
          const reader = new FileReader();
          reader.onloadend = () => {
            setFormData({
              ...formData,
              [e.target.id]: file,
            });
            setCurrentImages({
              ...currentImages,
              [e.target.id]: reader.result,
            });
          };
          reader.readAsDataURL(file);
        }
      };
    
    
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      };
    
      const handleUpdate = async () => {
        const form = new FormData();
        Object.keys(formData).forEach((key) => {
          if (formData[key]) {
            form.append(key, formData[key]);
          }
        });    
    
        try {
          const response = await EditCeoMessageApi(1, form);
          toast.success("Updated successfully!");
          console.log("Updated data:", response.data);
        } catch (error) {
          toast.error("Failed to update. Please try again.");
        }
      };
  return (
    <>
        <div>
        <div className="max-w-6xl mx-auto p-6 bg-white shadow-lg rounded-lg mt-3  dark:!bg-navy-700 dark:text-white">
          <h2 className="text-center text-3xl font-bold mb-5 mt-2">CEO Message</h2>
          <hr className="mb-4" />
          <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-4 mt-5">
            {/* Image Uploads */}
            {/* image*/}
            <div className="sm:col-span-2 flex flex-col sm:flex-row items-center sm:justify-between mt-4">
              <div className="sm:w-1/2 flex justify-center mb-4 sm:mb-0">
                {currentImages.image && (
                  <img
                    src={currentImages.image}
                    alt="Current Background Image"
                    className="rounded shadow-md"
                    style={{ height: "130px", width: "150px" }}
                  />
                )}
              </div>
              <div className="sm:w-1/2 text-center">
                <label htmlFor="image" className="block font-medium text-gray-900 mb-2">
                  image
                </label>
                <input
                  type="file"
                  id="image"
                  accept="image/*"
                  className="hidden"
                  onChange={handleImageUpload}
                />
                <button
                  type="button"
                  onClick={() => document.getElementById("image").click()}
                  className="px-4 py-2 bg-purple-600 text-white rounded-md shadow hover:bg-purple-700"
                >
                  <MdUpload />
                </button>
                <p className="mt-2" style={{ fontSize: '10px' }}>The height and width must be 1080 × 1350</p>

              </div>
            </div>




            {/*Description */}
            <div className="sm:col-span-4">
              <label htmlFor="description" className="block font-medium text-gray-900">Description</label>
              <div className="mt-2">
                <textarea
                  name="description"
                  id="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>

            {/*Point 1*/}
            <div className="sm:col-span-4">
              <label htmlFor="point1" className="block font-medium text-gray-900">Point 1</label>
              <div className="mt-2">
                <textarea
                  name="point1"
                  id="point1"
                  value={formData.point1}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>

            {/*Point 2*/}
            <div className="sm:col-span-4">
              <label htmlFor="point2" className="block font-medium text-gray-900">Point 2</label>
              <div className="mt-2">
                <textarea
                  name="point2"
                  id="point2"
                  value={formData.point2}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>

            {/*Point 3*/}
            <div className="sm:col-span-4">
              <label htmlFor="point3" className="block font-medium text-gray-900">Point 3</label>
              <div className="mt-2">
                <textarea
                  name="point3"
                  id="point3"
                  value={formData.point3}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>
{/*description_second */}
<div className="sm:col-span-4">
              <label htmlFor="description_second" className="block font-medium text-gray-900">description_second</label>
              <div className="mt-2">
                <textarea
                  name="description_second"
                  id="description_second"
                  value={formData.description_second}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>
            {/*description_third */}
            <div className="sm:col-span-4">
              <label htmlFor="description_third" className="block font-medium text-gray-900">description_third</label>
              <div className="mt-2">
                <textarea
                  name="description_third"
                  id="description_third"
                  value={formData.description_third}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>
         
            {/*Name */}
            <div className="sm:col-span-2">
              <label htmlFor="name" className="block font-medium text-gray-900">Name</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="name"
                  id="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white" 
                />
              </div>
            </div>
            {/*Role*/}
            <div className="sm:col-span-2">
              <label htmlFor="role" className="block font-medium text-gray-900">Role</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="role"
                  id="role"
                  value={formData.role}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>
            {/*company */}
            <div className="sm:col-span-2">
              <label htmlFor="company" className="block font-medium text-gray-900">Company</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="company"
                  id="company"
                  value={formData.company}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>
            {/*linkdin */}
            <div className="sm:col-span-2">
              <label htmlFor="linkdin" className="block font-medium text-gray-900">Linkdin</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="linkdin"
                  id="linkdin"
                  value={formData.linkdin}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>
          

            {/*instagram */}
            <div className="sm:col-span-2">
              <label htmlFor="instagram" className="block font-medium text-gray-900">Instagram</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="instagram"
                  id="instagram"
                  value={formData.instagram}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>

           
          </div>
          <hr className="mt-5 mb-5" />
          <div className="flex justify-center">
            <button
              type="button"
              onClick={handleUpdate}
              className="px-4 py-2 bg-purple-600 text-white rounded-md shadow hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500"
            >
              Update
            </button>
          </div>
        </div>
      </div>
 
    </>
  )
}

export default CeoMessage